import { message } from 'antd';

import { getRandomNumber } from 'src/shared/utils/get-random-number';
import { showErrorMessage } from 'src/shared/utils/messages';

import { ErrorMessage } from './error-message';

export const showCustomErrorMessage = (headerText: string, errorsList: string[], duration?: number) => {
  const key = getRandomNumber();

  const onClose = () => {
    message.destroy(key);
  };

  showErrorMessage(<ErrorMessage headerText={headerText} errorsList={errorsList} onClose={onClose} />, {
    duration,
    key,
  });
};
